import { render, staticRenderFns } from "./SentimentChart.vue?vue&type=template&id=4d46c360&scoped=true&"
import script from "./SentimentChart.vue?vue&type=script&lang=js&"
export * from "./SentimentChart.vue?vue&type=script&lang=js&"
import style0 from "./SentimentChart.vue?vue&type=style&index=0&id=4d46c360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46c360",
  null
  
)

export default component.exports